@if (store) {
<div>
    @switch (store.isOpenToday && store.isOpenNow) {
    @case (true) {
    <span class="col-3 s1 ">{{'Open'|translate}}</span>
    <span class="p1 col-11">
        <span class="p-l-1 p-r-1 inline-block">•</span>{{'Closes at' | translate}}
        {{store.todayOpeningHours?.close}}
    </span>
    }
    @default {
    <span>
        <span class="col-2 s1">{{'Closed' | translate}}</span>
    </span>
    }
    }
</div>
}